<template>
  <div :class="$style.page">
    <div :class="$style.card">
      <div :class="$style.iconWrap">🎟️</div>
      <h1 :class="$style.title">무료초대권 등록</h1>
      <p :class="$style.desc">받으신 초대권 코드를 입력하시면<br />무료로 공연을 예매할 수 있어요.</p>

      <div :class="$style.inputWrap">
        <input v-model="code" :class="[$style.codeInput, { [$style.error]: errorMsg }]" type="text"
          placeholder="초대권 코드를 입력하세요" maxlength="30" @keyup.enter="submitCode" :disabled="loading" />
        <p v-if="errorMsg" :class="$style.errorMsg">{{ errorMsg }}</p>
      </div>

      <button :class="$style.submitBtn" :disabled="!code.trim() || loading" @click="submitCode">
        <span v-if="loading">확인 중…</span>
        <span v-else>등록하기</span>
      </button>

      <button :class="$style.backBtn" @click="$router.back()">← 돌아가기</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "InviteRegister",
  data() {
    return {
      code: "",
      loading: false,
      errorMsg: "",
    };
  },
  methods: {
    async submitCode() {
      const trimmed = this.code.trim();
      if (!trimmed) return;
      this.errorMsg = "";
      this.loading = true;
      try {
        // TODO: 실제 초대권 코드 검증 로직 연결
        await new Promise((r) => setTimeout(r, 800));
        alert(`코드 "${trimmed}" 등록이 완료되었습니다.`);
        this.code = "";
      } catch {
        this.errorMsg = "유효하지 않은 초대권 코드입니다.";
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style module>
.page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f8fafc;
  padding: 40px 16px;
}

.card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(0, 0, 0, 0.08);
  padding: 48px 36px 40px;
  width: 100%;
  max-width: 400px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
}

.iconWrap {
  font-size: 2.8rem;
  line-height: 1;
}

.title {
  font-size: 1.4rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
}

.desc {
  font-size: 0.875rem;
  color: #64748b;
  text-align: center;
  line-height: 1.7;
  margin: 0;
}

.inputWrap {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 6px;
}

.codeInput {
  width: 100%;
  border: 1.5px solid #e2e8f0;
  border-radius: 10px;
  padding: 13px 16px;
  font-size: 0.95rem;
  color: #1e293b;
  outline: none;
  transition: border-color 0.2s;
  box-sizing: border-box;
  text-align: center;
  letter-spacing: 0.08em;
}

.codeInput:focus {
  border-color: #f070a3;
}

.codeInput.error {
  border-color: #ef4444;
}

.codeInput:disabled {
  background-color: #f8fafc;
  color: #94a3b8;
}

.errorMsg {
  font-size: 0.78rem;
  color: #ef4444;
  text-align: center;
  margin: 0;
}

.submitBtn {
  width: 100%;
  background-color: #f070a3;
  color: #fff;
  border: none;
  border-radius: 10px;
  padding: 14px;
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s;
}

.submitBtn:hover:not(:disabled) {
  background-color: #e0508a;
}

.submitBtn:disabled {
  background-color: #fbb6d4;
  cursor: not-allowed;
}

.backBtn {
  background: none;
  border: none;
  color: #94a3b8;
  font-size: 0.82rem;
  cursor: pointer;
  padding: 0;
  margin-top: -8px;
}

.backBtn:hover {
  color: #64748b;
}

@media (max-width: 480px) {
  .card {
    padding: 36px 20px 32px;
    gap: 16px;
  }
}
</style>
